import { useState, useEffect, useContext } from "react";
import { api } from "services/api";
import { getInitialObject } from "utils/globalFunctions";
import Swal from "sweetalert2";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import ReactLoading from "react-loading";
import { Customer } from "./Customer";
import { Premix } from "./Premix";
import { Enzymes } from "./Enzymes";
import { Health } from "./Health";
import { Minerals } from "./Minerals";
import { Additions } from "./Additions";
import { Modal } from "components/Modal";
import { Icons } from "components/Icons";
import { Button } from "components/Button";
import UpdateList from "contexts/updateList";
export function CreateEdit(props) {
  const { setUpdateList } = useContext(UpdateList);

  const meggInit = {
    _id: null,
    dailySlaughter: "",
    healthScore: "",
    healthChallenge: "",
    knownAgents: "",
    antibiogramRecent: "",
    export: false,
    internMarket: false,
    exportCuts: "",
    exportPlaces: [],
    premixProductionYear: "",
    premixComposition: "",
    premixPlaxma: false,
    premixHemoglobin: false,
    premixAnimalFeed: false,
    premixAnimalFeedType: "",
    premixSteps: {
      pre: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
      initial: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
      growth: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
      development: {
        feedProductionYear: "",
        physicalForm: "",
        provider: "",
        commonDescription: "",
        pxClass: "",
      },
    },
    enzymes: {
      phytase: {
        pre: {
          checked: false,
          product: "",
        },
        initial: {
          checked: false,
          product: "",
        },
        growth: {
          checked: false,
          product: "",
        },
        development: {
          checked: false,
          product: "",
        },
      },
      phytaseHidosing: {
        pre: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        initial: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        growth: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },
        development: {
          checked: false,
          type: "",
          product: "",
          dose: "",
        },

        approved: {
          checked: false,
          reason: "",
        },
      },
      carbohydraseBlends: {
        pre: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        initial: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        growth: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        development: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },

        approved: {
          checked: false,
          reason: "",
        },
      },
      enziPacProProtease: {
        pre: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        initial: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        growth: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },
        development: {
          checked: false,
          product: "",
          goal: "",
          dose: "",
        },

        approved: {
          checked: false,
          reason: "",
        },
      },
    },
    health: {
      anticoccidian: {
        qualipac: false,
        action: "",
        why: "",
        moleculePre: "",
        moleculeInitial: "",
        moleculeGrowth: "",
        moleculeDevelopment: "",
        rotation: "",
        powderGranular: "",
        additional: false,
      },
      therapeuticMedication: {
        pre: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
        initial: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
        growth: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
        development: {
          checked: false,
          type: "",
          product: "",
          dose: "",
          water: false,
        },
      },
      performanceEnhancer: {
        pre: {
          checked: false,
          product: "",
          from: "",
          to: "",
          dose: "",
        },
        initial: {
          checked: false,
          product: "",
          from: "",
          to: "",
          dose: "",
        },
        growth: {
          checked: false,
          product: "",
          from: "",
          to: "",
          dose: "",
        },
        development: {
          checked: false,
          product: "",
          from: "",
          to: "",
          dose: "",
        },
      },
    },
    minerals: {
      organics: {
        pre: {
          checked: false,
          product: "",
          reason: "",
        },
        initial: {
          checked: false,
          product: "",
          reason: "",
        },
        growth: {
          checked: false,
          product: "",
          reason: "",
        },
        development: {
          checked: false,
          product: "",
          reason: "",
        },
        unknownConcept: false,
      },
      zincOxide: {
        pre: {
          checked: false,
          ppm: "",
        },
        initial: {
          checked: false,
          ppm: "",
        },
        growth: {
          checked: false,
          ppm: "",
        },
        development: {
          checked: false,
          ppm: "",
        },
      },
      copperSulfate: {
        pre: {
          checked: false,
          ppm: "",
        },
        initial: {
          checked: false,
          ppm: "",
        },
        growth: {
          checked: false,
          ppm: "",
        },
        development: {
          checked: false,
          ppm: "",
        },
      },
    },
    additions: {
      organicAcids: {
        pre: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        initial: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        growth: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        development: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        unknownConcept: false,
      },
      mycotoxinAdsorbents: {
        pre: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        initial: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        growth: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        development: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        unknownConcept: false,
      },
      essencialOils: {
        pre: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        initial: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        growth: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        development: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
      },
      prebiotics: {
        pre: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        initial: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        growth: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        development: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
      },
      probiotics: {
        pre: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        initial: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        growth: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
        development: {
          checked: false,
          product: "",
          reason: "",
          dose: "",
        },
      },
      others: {
        emulsifiers: false,
        pigmentation: false,
        pigmentationType: "",
        pre: {
          yellowppm: "",
          redppm: "",
        },
        initial: {
          yellowppm: "",
          redppm: "",
        },
        growth: {
          yellowppm: "",
          redppm: "",
        },
        development: {
          yellowppm: "",
          redppm: "",
        },
      },
    },
  };

  const [loading, setLoading] = useState(true);

  const [getMegg, setGetMegg] = useState(true);

  const [config, setConfig] = useState({});

  const [megg, setMegg] = useState(meggInit);

  const [tab, setTab] = useState(0);

  const saveMegg = async (e) => {
    const requestMegg = { ...megg };
    requestMegg.customer = props.customer;
    requestMegg._id = props.id || null;
    const response = await Swal.fire({
      title: "Histórico de Produção de Frango de Corte",
      text: "Deseja salvar alterações?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0451e8",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, Salvar!",
      showLoaderOnConfirm: true,
      preConfirm: async () =>
        props.id
          ? await api
              .put("megghistoric/" + props.id, requestMegg)
              .catch((err) => ({
                err: true,
                data: { message: err.response.data.message },
              }))
          : await api.post("megghistoric", requestMegg).catch((err) => ({
              err: true,
              data: { message: err.response.data.message },
            })),
    });
    if (response.value) {
      Swal.fire(
        "Histórico de Produção de Frango de Corte",
        response.value.data.message,
        response.value.err ? "error" : "success"
      );
    }
    setUpdateList(true);
  };

  useEffect(() => {
    const loadMegg = async () => {
      setLoading(true);
      const responseConfig = await api.get("megghistoric/config", {
        params: {
          query:
            "premixComposition premixAnimalFeedType premixPhysicalForm premixCommonDescription " +
            "customerHealthScore customerExportCuts enzymesPhytaseProduct enzymesPhytaseType " +
            "enzymesCarbohydraseBlendsProduct enzymesEnziPacProProteaseProduct healthAnticoccidianMolecule " +
            "healthTherapeuticMedicationType healthTherapeuticMedicationProduct healthPerformanceEnhancerProduct " +
            "mineralsOrganicsProduct additionsOrganicAcidsProduct additionsMycotoxinAdsorbentsProduct " +
            "additionsEssencialOilsProduct additionsPrebioticsProduct additionsProbioticsProduct othersPigmentationType",
        },
      });

      if (!responseConfig.data) {
        Swal.fire(
          "Editar Configurações",
          "Não foi possível buscar configurações",
          "error"
        );
      }
      setConfig([...responseConfig.data]);

      const response = await api.get(
        props.id
          ? `megghistoric/edit/${props.id}`
          : `megghistoric/${props.customer}`
      );
      if (!response.data) {
        return setLoading(false);
      }
      const meggCopy = getInitialObject({ ...megg }, response.data);

      setMegg(meggCopy);
      setLoading(false);
    };
    if (getMegg) {
      setGetMegg(false);
      loadMegg();
    }
  }, [megg, getMegg, props.customer, props.id]);

  return (
    <Modal
      show={props.show}
      close={() => props.setShow(false)}
      header={
        <>
          <Icons type="megg" color="#009870" size={30} />
          <h2>Histórico de Programas - Cria - Recria - MEgg</h2>
        </>
      }
      footer={
        <Button color="white" bg="default" border="default" onClick={saveMegg}>
          Salvar
        </Button>
      }
    >
      {loading ? (
        <ReactLoading type="spin" color="#009870" height={30} width={30} />
      ) : (
        <>
          <Tabs
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="on"
            onChange={(e, value) => {
              setTab(value);
            }}
          >
            <Tab label="Cliente" />
            <Tab label="Premix/Ração" />
            <Tab label="Enzimas" />
            <Tab label="Saúde" />
            <Tab label="Minerais" />
            <Tab label="Aditivos" />
          </Tabs>
          {tab === 0 && (
            <Customer
              megg={megg}
              setMegg={setMegg}
              config={config}
              editing={props.editing}
            />
          )}
          {tab === 1 && (
            <Premix megg={megg} setMegg={setMegg} config={config} />
          )}
          {tab === 2 && (
            <Enzymes megg={megg} setMegg={setMegg} config={config} />
          )}
          {tab === 3 && (
            <Health megg={megg} setMegg={setMegg} config={config} />
          )}
          {tab === 4 && (
            <Minerals megg={megg} setMegg={setMegg} config={config} />
          )}
          {tab === 5 && (
            <Additions megg={megg} setMegg={setMegg} config={config} />
          )}
        </>
      )}
    </Modal>
  );
}
